import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row pb-4" }
const _hoisted_2 = { class: "col-sm-7 text-sm-end text-center mt-3 mt-sm-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-sm-5\"><div class=\"pe-md-5 me-md-5\"><form class=\"src-form position-relative\"><input type=\"text\" class=\"form-control\" style=\"height:45px;\" placeholder=\"Search here.....\"><button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 border-0\"><span class=\"material-symbols-outlined position-relative top-5 text-primary pe-2\"> search </span></button></form></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        to: "/real-estate/add-property",
        class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block" }, null, -1),
          _createElementVNode("span", null, "Add Property", -1)
        ])),
        _: 1
      })
    ])
  ]))
}